import type { DataType, FieldSchema, Operator } from 'Listrak.Customer.Segmentation.Api.Client';

export enum InputEnum {
  Text = 'atlas-text-input',
  TextArea = 'atlas-textarea',
  Date = 'atlas-date-input',
  DateRange = 'date-range',
  Number = 'atlas-number-input',
  NumberRange = 'atlas-number-range',
  LabeledNumberInput = 'atlas-labeled-number-input',
  LabeledNumberInputRange = 'relative-number-range',
  BaseDropdown = 'atlas-base-dropdown',
}

export type InputTag = `${InputEnum}`;

export type InputType = {
  [key in DataType]?: InputTag
};

export type RelativeDateType =
| 'DaysFromToday0'
| 'DaysFromToday7'
| 'DaysFromToday30'
| 'DaysFromToday365'
| 'DaysFromTodayNegative'
| 'DaysFromTodayPositive'
| 'DaysFromTodayMonthDay0'
| 'InBetweenDaysFromTodayNegative'
| 'InBetweenDaysFromTodayPositive';

export type RelativeDateValueType = Exclude<RelativeDateType, 'DaysFromTodayNegative' | 'DaysFromTodayPositive'>;

export type RelativeDateInputType = {
  [key in RelativeDateType]?: InputTag;
};

export type RelativeDateText = {
  [key in RelativeDateType]: string;
}

export type RelativeDateValue = {
  [key in RelativeDateValueType]: string;
}

export type InputText = {
  [key in DataType]?: string;
};

export type OperatorDefinition = {
  text: InputText;
  inputType?: InputType & RelativeDateInputType;
  formatter?: {
    [key in DataType]?: (values: string[], rule?: FieldSchema) => string
  }
};

export type OperatorDictionary = {
  [key in Operator]: OperatorDefinition;
};
